// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"c39600e2","82":"16fa57f6","208":"9ee9ba54","253":"72bbf87d","488":"996c6a8c","572":"762cb38a","671":"a0ab305e","784":"06c83441","815":"d286b40b","885":"3c760a5c"}[chunkId] + ".chunk.js";
};